import { FETCH_TRANSLATIONS_SUCCESS as FETCH_AUDIT_MODEL_TRANSLATIONS_SUCCESS } from 'modules/auditModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';
import type {
  AuditModelTranslationsSuccessAction,
  FetchTranslationsSuccessAction,
  TranslationsByLocale,
} from '../../types';

const initialState: TranslationsByLocale = {};

const add = (
  state: TranslationsByLocale,
  { payload }: FetchTranslationsSuccessAction | AuditModelTranslationsSuccessAction
): TranslationsByLocale =>
  Object.entries(payload).reduce<TranslationsByLocale>(
    (newState, [locale, translations]) => ({
      ...newState,
      [locale]: {
        ...(newState[locale] ?? {}),
        ...translations,
      },
    }),
    { ...state }
  );

export default createReducer<TranslationsByLocale>(initialState, {
  [FETCH_AUDIT_MODEL_TRANSLATIONS_SUCCESS]: add,
  [types.FETCH_TRANSLATIONS_SUCCESS]: add,
});
